'use client'

import { useState } from 'react'
import { Check, Copy } from 'lucide-react'
import { analytics } from '@/lib/analytics'

const snippet = '<iframe src="https://prepublish.ai/embed/words-to-minutes" width="100%" height="420" style="border:0" title="Words to Minutes Calculator"></iframe>'

export function WordsToMinutesEmbed() {
  const [copied, setCopied] = useState(false)

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(snippet)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
      analytics.track('embed_snippet_copied', { tool: 'words_to_minutes' })
    } catch {
      // Clipboard access is optional; the snippet remains selectable.
    }
  }

  return (
    <section className="mt-12 rounded-lg border border-border bg-card p-5">
      <h2 className="text-lg font-semibold text-foreground">Embed this tool</h2>
      <p className="mt-1 text-sm text-muted-foreground">Free to embed on any site. The widget links back here.</p>
      <div className="mt-4 flex gap-2">
        <code className="min-w-0 flex-1 overflow-x-auto rounded-md bg-background px-3 py-2 text-xs text-muted-foreground whitespace-nowrap">
          {snippet}
        </code>
        <button
          type="button"
          onClick={copy}
          className="inline-flex shrink-0 items-center gap-1.5 rounded-md border border-border px-3 py-2 text-sm font-medium text-foreground hover:bg-muted"
        >
          {copied ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />}
          {copied ? 'Copied' : 'Copy'}
        </button>
      </div>
    </section>
  )
}
